<script>
	import listBase from '@_system/components/base/list.vue'
	import reportTree from '@_system/components/formcomponents/common/select/report/tree.vue'
	export default {
		extends: listBase,
		name: 'reportIndex',
		props: {

		},
		render(h) {
			this.$slots.mainheader = [
				<el-button size="mini" type="primary" onClick={this.listfieldconfig}>列表字段</el-button>]
			this.$slots.aside = [
				<report-tree ref="reporttTree" key={this.reporttTreeKey} onSelect={this.reporttTreeChange} />
			]
			this.$slots.header = [
				<el-breadcrumb separator-class="el-icon-arrow-right" >
					{
						this.parentbread.length!=0?this.parentbread.map((item,index)=>{
						return <el-breadcrumb-item key={index}>{item.name}</el-breadcrumb-item>
					}):<el-breadcrumb-item>请选择</el-breadcrumb-item>
					
					}			
				</el-breadcrumb>
			]
		
			return listBase.render.call(this, h)
		},
		data() {
			return {
				componenttype: 'system',
				moduleName: 'reportcontroll',
				windowName: '报表管理',
				reportid: 0,
				gridShow:false,
				// reportname: '',
				field: '',
				parentbread: [],
				toolbarbutton: [],
				operatebutton: [],
				reporttTreeKey: Math.random(),
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				},
				listShow: true,
				listformData: {
					name: 'reportlist',
					id: 0,
					controlltype: 1,
					show: false
				},
			}
		},
		watch: {
			reportid(v){
				this.gridShow = v
			}
		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			reporttTreeChange(e) {
				// this.reportname = e.name
				this.controller = e.controller
				this.parentbread = e.parentbread
				this.toolbarbutton = e.toolbarbutton
				this.operatebutton = e.operatebutton
				this.listfield = e.listfield
				if (e.component) {
					this.reportid = e.id
					this.customreload()
				} else {
					this.reportid = 0
				}

			},
			beforeRequest(form) {
				form.reportid = this.reportid
			},
			beforeCreateGrid(formConfig, columns, options) {
				options.pagerConfig = {
					layouts: [],
					currentPage: 1,
					pageSize: 999,

				}
			},
			add() {
				import('@_system/components/forms/report/controll/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'reportcontroll',
						id: 0,
						controlltype: 1,
						show: true,
						foreingKey: {
							reportid: this.reportid,
						},
						extra: {
							toolbarbutton: this.toolbarbutton,
							operatebutton: this.operatebutton,
							listfield:this.listfield
						}
					}
				})
			},
			edit(row) {
				import('@_system/components/forms/report/controll/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'reportcontroll',
						id: row.id,
						controlltype: 2,
						show: true,
						foreingKey: {
							reportid: this.reportid,
						},
						extra: {
							toolbarbutton: this.toolbarbutton,
							operatebutton: this.operatebutton,
							listfield:this.listfield
						}
					}
				})
			},
			del(row) {
				this.$confirm('是否删除 ' + row.name, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.reportcontroll.delete(row.id).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					})
				}).catch(() => {

				})
			},
			listfieldconfig() {

				if (this.reportid != 0) {
					//alert(123)
				
					import('@_system/components/forms/report/listfield/form.vue').then((res) => {
				
						this.formModule = {
							component: res.default,
							name: 'report',
							id:this.reportid,
							controlltype: 2,
							show: true,
							foreingKey: {
					
							},
							extra: {
								controller:this.controller
							}
						}
					})
				} else {
					this.$message.error({
						message: '请选择报表',
					})
				}
			},
			auth(row) {
				import('@_system/components/forms/auth/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'auth',
						id: row.id,
						show: true,
						extra: {
							type: 'reportcontroll',
						}
					}
				})
			},
			formBack() {
				//let component = this.formModule.component
				if(this.formModule.name=='report'){
					this.reloadlist()
					this.reportid = 0
				}
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
					extra: {},
					foreingKey: {},
				}
				this.customreload()
				

			},
			reloadlist() {
				this.reporttTreeKey = Math.random()
			}
		},
		components: {
			reportTree,


		}
	}
</script>
